import React from 'react';
import './BackgroundImage.scss';

import bgImg from './assets/bg-img.png';
import bgImg2x from './assets/bg-img@2x.png';
import bgImg3x from './assets/bg-img@3x.png';

import bgImgDesktop from './assets/bg-img-desktop.png';
import bgImgDesktop2x from './assets/bg-img-desktop@2x.png';
import bgImgDesktop3x from './assets/bg-img-desktop@3x.png';

const BackgroundImage = () => (
    <div className="BackgroundImage" data-testid="BackgroundImage">
        <picture>
            <source media="(max-width: 991px)" srcSet={`${bgImg}, ${bgImg2x}, ${bgImg3x}`} />
            <source media="(min-width:767px)" srcSet={`${bgImgDesktop}, ${bgImgDesktop2x}, ${bgImgDesktop3x}`} />
            <img src={bgImg} alt="background" />
        </picture>
    </div>
);
export default BackgroundImage;
